<script>
import Label from './Label.vue'
import * as categoryService from '../../../components/service/category.service';

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        // type: Object || String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        last_updated: {
            type: Object,
            required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value,
            options: [],
            d_check: this.selectedItem ? this.selectedItem[this.item.displayOn] : false
        };
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.d_check;
            },
            set: function (newValue) {
                this.d_check = newValue;
            }
        }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                if(this.value != val) this.value = val;
            },
            deep: true
        },
        value(val) { 
            this.updateValue(this.item_key, val);
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }
    },
    methods: {
        selectedLocation(loc) {
            if(this.value.find(x => x.id == loc.id)) {
                this.value = this.value.filter(x => x.id != loc.id)
            } else {
                this.value.push(loc)
            }
        },
        async getOptions() {
            let filter = {
                "where": {
                "name": "Locations",
                "cmsId": this.$route.params.cmsId
                },
                "include": [
                {
                    "relation": "pages"
                }
                ]
            };

            filter = encodeURIComponent(JSON.stringify(filter));
            
            let data = await categoryService.getWithFilter(filter)

            let pages = data[0].pages;
            if(pages) this.options = pages;
        },
    },
    async mounted() {
        this.item.display = false
        await this.getOptions()
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <Label :item="item"/>
        <div class="row col-12">
            <div v-for="option in options" v-bind:key="option.id" class="form-check col-4 mb-2">
                <input class="form-check-input" type="checkbox" :id="option.id" :name="option.id"
                :value="!!value.find(x => x.id == option.id)"
                :checked="!!value.find(x => x.id == option.id)"
                @input="selectedLocation(option)"
                >
                <label :for="option.id" class="form-check-label font-weight-medium">{{option.title}}</label>
            </div>
        </div>

        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



